import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=be442dac&scoped=true&"
import script from "./PushList.vue?vue&type=script&lang=js&"
export * from "./PushList.vue?vue&type=script&lang=js&"
import style0 from "./PushList.vue?vue&type=style&index=0&id=be442dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be442dac",
  null
  
)

export default component.exports